import { FontEntry } from '../../types/font'

export const classicGrotesquePro: FontEntry = {
  displayName: 'classic-grotesque-pro',
  weights: {
    300: {
      normal: { file: 'ClassicGrotesquePro-Light', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    400: {
      normal: { file: 'ClassicGrotesquePro-Regular', extension: 'woff2', format: 'woff2' },
      italic: null
    },
    600: {
      normal: { file: 'ClassicGrotesquePro-SemiBold', extension: 'woff2', format: 'woff2' },
      italic: null
    }
  }
}
